import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {DynamicSettings} from '../@models/settings';
import {LanguageCode} from '../../shared-gen/Model/Localization/LanguageCode';
import {DynamicSettingsFun} from '../@models/settings.fun';
import {BehaviorSubject} from 'rxjs';


/**
 * Service for dynamic program settings.
 * Call and await `init()` before using this service.
 *
 * OBSOLETE? Currently there are no setting items.
 */
@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    settings: BehaviorSubject<DynamicSettings> = new BehaviorSubject<DynamicSettings>(DynamicSettingsFun.createNew());

    constructor(private storage: LocalStorage,
                private route: ActivatedRoute,
                private httpClient: HttpClient) {
    }

    async init() {
        const storageSettings = (await this.storage.getItem<DynamicSettings>('settings').toPromise())
                || {} as DynamicSettings;
        if (storageSettings) {
        	const mergedSettings = this.settings.getValue();
            // Currently no settings... nothing to merge
            this.settings.next(mergedSettings);
        }
    }

    private save() {
        this.storage.setItem('settings', this.settings.getValue()).subscribe();
    }

}
